// extracted by mini-css-extract-plugin
export default {"benContainer":"About_benContainer__elUyL","ben":"About_ben__orf+o"};